<template>
    <div class="disease-result">
        <section
            v-for="block in moduleBlocks"
            :key="block.type"
            :id="block.id"
            class="module-block"
            :class="block.type"
        >
            <div class="module-head">
                <div class="head-left">
                    <span class="side-icon" v-html="icons[block.type]"></span>
                    <div class="head-text">
                        <h4>{{ block.title }}</h4>
                        <p>{{ block.desc }}</p>
                    </div>
                </div>
                <div class="jump-btn" @click="goModule(block.type)">
                    进入{{ block.title }}<i class="el-icon-d-arrow-right"></i>
                </div>
            </div>
            <div class="module-body" :class="{ 'kp-body': block.type === 'science' }">
                <div v-for="item in block.charts" :key="item.key" class="chart-box">
                    <p class="chart-box-tit">{{ item.title }}</p>
                    <div class="chart-img">
                        <img :src="item.img" :alt="item.title">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
const iconSvg = {
    doctor: '<svg t="1788153300679" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3688"><path d="M358.4 580.266667a34.133333 34.133333 0 0 1 34.048 31.573333L392.533333 614.4v65.826133C392.533333 784.554667 480.733867 870.4 588.8 870.4c106.376533 0 193.501867-83.2 196.1984-185.2928l0.068267-4.881067a34.133333 34.133333 0 0 1 68.181333-2.56l0.085333 2.56C853.333333 822.6304 734.173867 938.666667 588.8 938.666667c-143.547733 0-261.546667-113.134933-264.482133-253.098667L324.266667 680.209067V614.4a34.133333 34.133333 0 0 1 34.133333-34.133333z" fill="currentColor" p-id="3689"></path><path d="M204.8 68.266667a34.133333 34.133333 0 0 1 2.56 68.181333L204.8 136.533333H136.533333v221.866667c0 121.941333 99.925333 221.866667 221.866667 221.866667 120.200533 0 218.999467-97.0752 221.7984-216.661334L580.266667 358.4V136.533333h-68.266667a34.133333 34.133333 0 0 1-2.56-68.181333L512 68.266667h68.266667a68.266667 68.266667 0 0 1 68.181333 64.853333L648.533333 136.533333v221.866667c0 159.658667-130.474667 290.133333-290.133333 290.133333-157.815467 0-287.1296-127.488-290.082133-284.637866L68.266667 358.4V136.533333a68.266667 68.266667 0 0 1 64.853333-68.181333L136.533333 68.266667h68.266667z" fill="currentColor" p-id="3690"></path><path d="M819.2 426.666667a136.533333 136.533333 0 1 0 0.034133 273.1008A136.533333 136.533333 0 0 0 819.2 426.666667z m0 68.266666a68.266667 68.266667 0 1 1-0.034133 136.567467A68.266667 68.266667 0 0 1 819.2 494.933333z" fill="currentColor" p-id="3691"></path></svg>',
    research: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="10" cy="10" r="5.5"/><path d="M14.2 14.2 20 21"/><path d="M8 10h4M10 8v4"/></svg>',
    science: '<svg t="1788163284759" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4760" width="200" height="200"><path d="M928.8 160.2H700c-49.1 0-97.1 14.1-138.4 40.7l-48.8 31.3-48.8-31.3c-41.2-26.6-89.3-40.7-138.4-40.7H96.8c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3 0.8 2.8 1.3 4.3 1.3s3-0.4 4.3-1.3l44.4-28.6c41.4-26.6 89.5-40.7 138.6-40.7h228.8c17.7 0 32-14.3 32-32v-568c0-17.7-14.3-32-32-32z m-603.2 560H136.8v-488h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39z m563.2 0H700c-54.4 0-107.6 13.4-155.2 39v-462l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2h188.8v488z" fill="#1D4ED8" p-id="4761"></path><path d="M397.7 360.2H211.9c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z m223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.9c-3.9 0-7.1 3.4-7.1 7.5zM397.7 500.2H211.9c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z m416 0H627.9c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z" fill="#1D4ED8" p-id="4762"></path></svg>',
};

const MODULE_BLOCKS = [
    {
        type: 'doctor',
        id: 'doctorModule',
        title: '医生模块',
        desc: '面向临床诊疗的结构化知识与决策支持入口',
        charts: [
            { key: 'sjt', title: '用药桑基图', img: require('@/assets/images/disease/ys-sjt.png') },
            { key: 'zl', title: '治疗知识图谱', img: require('@/assets/images/disease/ys-zl.png') },
            { key: 'rlt', title: '病因病机柱状堆积图', img: require('@/assets/images/disease/ys-djt.png') },
            { key: 'zd', title: '诊断标签区', img: require('@/assets/images/disease/ys-zd.png') },
        ],
    },
    {
        type: 'research',
        id: 'researchModule',
        title: '科研模块',
        desc: '面向证据整合与研究探索的科研入口',
        charts: [
            { key: 'wx', title: '科研文献支撑区', img: require('@/assets/images/disease/ky-wx.png') },
            { key: 'lcsyt', title: '临床试验图谱', img: require('@/assets/images/disease/ky-lcsyt.png') },
            { key: 'syt', title: '基础实验图谱', img: require('@/assets/images/disease/ky-syt.png') },
            { key: 'qt', title: '其他图谱与表格', img: require('@/assets/images/disease/ky-qt.png') },
        ],
    },
    {
        type: 'science',
        id: 'scienceModule',
        title: '科普模块',
        desc: '面向公众认知与健康管理的科普入口',
        charts: [
            { key: 'tj', title: '医家知识统计分析', img: require('@/assets/images/disease/kp-tj.png') },
            { key: 'zzsjt', title: '症状桑基图', img: require('@/assets/images/disease/kp-zzsjt.png') },
            { key: 'zzt', title: '症状图谱', img: require('@/assets/images/disease/kp-zzt.png') },
            { key: 'hl', title: '护理图谱', img: require('@/assets/images/disease/kp-hl.png') },
            { key: 'bt', title: '护理饼图', img: require('@/assets/images/disease/kp-bt.png') },
        ],
    },
];

export default {
    name: 'DiseaseResult',
    props: {
        // 页面检索框当前输入：未点击「检索」时地址栏还没有检索词，这里作为检索词来源。
        searchWord: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            icons: iconSvg,
            moduleBlocks: MODULE_BLOCKS,
        };
    },
    computed: {
        diseaseWord() {
            // 检索词优先取页面检索框当前输入，其次取地址栏 word。
            return this.searchWord || this.$route.query.word || '';
        },
    },
    methods: {
        goModule(type) {
            // 未输入检索词时提示，不进行跳转。
            if (!this.diseaseWord) {
                this.$message.warning('请输入检索词～');
                return;
            }
            this.$router.push({
                path: '/diseaseGraph',
                query: {
                    word: this.diseaseWord,
                    tab: type,
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.disease-result {
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(56, 109, 232, 0.08);

    .jump-btn {
        display: flex;
        align-items: center;
        height: 36px;
        padding: 0 14px;
        color: #165DFF;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #fff;
        border: 1px solid #165DFF;
        border-radius: 10px;
        &:hover {
            font-weight: bold;
            background: #165DFF;
            color: #fff;
            i {
                color: #fff;
            }
        }
    }

    .module-block {
        margin-bottom: 40px;
        scroll-margin-top: 86px;
    }

    .module-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        padding: 4px 0;
        .head-left {
            display: flex;
            align-items: center;
            justify-content: flex-start;
        }
        .side-icon {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            flex-shrink: 0;

            ::v-deep svg {
                width: 22px;
                height: 22px;
                display: block;
            }
            ::v-deep [fill] {
                fill: currentColor;
            }
        }
        .head-text {
            flex: none;
            margin-right: 16px;
            h4 {
                margin: 0 0 2px;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
            }
            p {
                margin: 0;
                font-size: 12px;
                line-height: 18px;
                color: #5A6779;
            }
        }
    }

    .doctor .module-head {
        .side-icon { color: #165DFF; background: #EAF1FF; }
        h4 { color: #165DFF; }
    }
    .research .module-head {
        .side-icon { color: #0F766E; background: #CCFBF1; }
        h4 { color: #0F766E; }
    }
    .science .module-head {
        .side-icon { color: #1D4ED8; background: #DBEAFE; }
        h4 { color: #1D4ED8; }
    }

    .module-body {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 16px;
        &.kp-body {
            grid-template-columns: repeat(5, minmax(0, 1fr));
        }
    }

    .chart-box {
        border: 1px solid #E8EEF8;
        border-radius: 12px;
        padding: 10px;
        min-width: 0;
        background: #fff;
    }

    .chart-box-tit {
        margin: 0 0 6px;
        font-size: 13px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 18px;
    }

    .chart-img {
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 6px;

        img {
            width: 100%;
            height: auto;
            max-height: 100%;
            object-fit: contain;
            display: block;
        }
    }
}
</style>
